import { Badge } from '@/components/ui/badge'
import type { ContentStatus } from '../api/contentApi'
import { CONTENT_STATUS_LABELS } from '../hooks/useContent'

const VARIANT: Record<ContentStatus, 'default' | 'secondary' | 'destructive' | 'outline'> = {
  draft: 'secondary',
  review: 'default',
  active: 'outline',
  seasonal: 'outline',
  archived: 'secondary',
  rejected: 'destructive',
}

export function ContentStatusBadge({ status }: { status: ContentStatus }) {
  return <Badge variant={VARIANT[status] || 'secondary'}>{CONTENT_STATUS_LABELS[status] || status}</Badge>
}

export function ConfidencePill({ value }: { value: number | null }) {
  if (value === null || value === undefined) return null
  const pct = Math.round(value * 100)
  const color =
    pct >= 85 ? 'bg-green-100 text-green-700' : pct >= 60 ? 'bg-amber-100 text-amber-700' : 'bg-red-100 text-red-700'
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${color}`}>{pct}%</span>
  )
}
